import React, { useEffect, useState } from "react";
import { Button, Image, NavBar, Popup } from "antd-mobile";
import { APPLICATION_SCREEN, ISwitchScreenAction } from "../App";
import moment from "moment";
import Holiday from "./HomeComponent/Holiday";
import { DEV_MODE, MAIN_COLOR_LIGHT } from "../common/Constants";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { firebaseConfig } from "./Splash";
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import Horoscope from "./HomeComponent/Horoscope";
import LifeNumber from "./HomeComponent/LifeNumber";
import TraPhatNguoi from "./HomeComponent/TraPhatNguoi";

enum FEATURES {
  HOROSCOPE,
  WEATHER,
  HOLIDAYS,
  LIFENUMBER,
  MINI_GAME,
  TRA_CUU_PHAT_NGUOI
}


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics();


// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app,'sharing-notes');

export default function Home({ setScreen } : ISwitchScreenAction) {
  const [annoucements, setAnnoucements] = useState('')
  const [feature, setFeature] = useState<FEATURES>(DEV_MODE ? FEATURES.HOROSCOPE : FEATURES.HOLIDAYS)
  const [showAnnoucePopup, setShowAnnouncePopup] = useState(false)
  const [isClosedMenu, setCloseMenu] = useState(true)

  const getAnnouces = async () => {
    const querySnapshot = await getDocs(collection(db, "announces"));
    const availableEvent: any[] = []
    querySnapshot.forEach((doc) => {
      const event = doc.data()
      if (event.date_end) {
          // Check if date is passed then ignore
          if (event.enable && moment(event.date_end, 'DD/MM/yyyy').isSameOrAfter(moment())) {
            availableEvent.push(event)
          } else {
            console.log('Event completed', event)
          }
      } else {
        availableEvent.push(event)
      }
    });

    const annoucements = []
    for (let index = 0; index < availableEvent.length; index++) {
      const element = availableEvent[index];
      console.log(availableEvent)
      annoucements.push(`${element.title} - ${element.content}`)
    }
    setAnnoucements(annoucements.join('. '))
  }
  
  useEffect(()=> {
    // setTimeout(()=> {
      if (db) {
        getAnnouces()
      }
    // })
  }, [db]);

  useEffect(()=> {
    const openMenuFirstTime = localStorage.getItem('first_time')
    console.log('firsttime:' + openMenuFirstTime)
    if (!openMenuFirstTime) {
      localStorage.setItem('first_time', 'completed')
      setTimeout(()=> {
        document.getElementById('menuIcon')?.click()
        setTimeout(()=> {
          document.getElementById('menuIcon')?.click()
          // Auto hide
        }, 1500)
      },1000)
    }

  }, [])

  const gotoFeature = async (openFeature: FEATURES) => {
    let menu = "horo_scope"
    if (openFeature === FEATURES.HOLIDAYS) {
      menu = "holidays"
    } else if (openFeature === FEATURES.MINI_GAME) {
      menu = "mini_game"
    } else if (openFeature === FEATURES.WEATHER) {
      menu = "weather"
    } else if (openFeature === FEATURES.TRA_CUU_PHAT_NGUOI) {
      menu = "tra_cuu_phat_nguoi"
    }
    logEvent(analytics, 'gift_click_menu_' + menu);
    if (feature === openFeature) {
      console.log('Already in!')
      return
    }
    // Hide menu
    document.getElementById('menuIcon')?.click()
    setCloseMenu(true)
    setFeature(openFeature)
  }

  const styleActive = {
    color: MAIN_COLOR_LIGHT,
    fontSize: 18,
    fontWeight: '700'
  }

  const styleInActive = {
    color: 'white',
    fontSize: 16,
    fontWeight: '700'
  }

  const showPopupAnnounce = () => {
    logEvent(analytics, 'gift_click_aunnounce');
    setShowAnnouncePopup(true)
  }

  return (
    <div style={{display: 'flex', flexDirection: 'column', fontSize: 18, fontWeight: 'bold', color: '#000000', paddingTop: 26}}>
     <div className="marquee-container" style={{position: 'fixed', top: 0, left: 0, paddingTop: 8, backgroundColor: 'white', paddingBottom: 8, paddingLeft: 120}}>
      <div  className="marquee-content">
          <span style={{marginLeft: 8}} onClick={showPopupAnnounce}>{annoucements}</span>
          {/* <span>{annoucements}</span>
          <span>{annoucements}</span> */}
      </div>
     </div>

     <Popup
        visible={showAnnoucePopup}
        onMaskClick={() => {
          setShowAnnouncePopup(false)
        }}
        onClose={() => {
          setShowAnnouncePopup(false)
        }}
        position='top'
        bodyStyle={{ minHeight: '20vh' }}
      >
        <div style={{margin: 16, fontSize: 18, fontWeight: 'bold'}}>{annoucements}</div>
      </Popup>
     
    {feature === FEATURES.HOLIDAYS && <Holiday setScreen={setScreen}/>}
    {feature === FEATURES.HOROSCOPE && <Horoscope setScreen={setScreen}/>}
    {feature === FEATURES.LIFENUMBER && <LifeNumber setScreen={setScreen}/>}
    {feature === FEATURES.TRA_CUU_PHAT_NGUOI && <TraPhatNguoi setScreen={setScreen}/>}
    <nav className={isClosedMenu ? "navigation-menu js-nav-menu" : "navigation-menu js-nav-menu navigation-menu--open"} onClick={()=> {
      setCloseMenu(!isClosedMenu)
    }}>
        <div id="menuIcon" className="navigation-menu__toggle js-nav-menu-toggle">
          <span className="navigation-menu__bars"></span>
        </div>
        <ul className="menu-list">
          <li className="menu-list__item" style={feature === FEATURES.HOLIDAYS ? styleActive : styleInActive} onClick={()=> {
            gotoFeature(FEATURES.HOLIDAYS)
          }}>Các ngày lễ trong năm</li>
          <li className="menu-list__item" style={feature === FEATURES.HOROSCOPE ? styleActive : styleInActive}  onClick={()=> {
            gotoFeature(FEATURES.HOROSCOPE)
          }}>Tử vi Cung Hoàng Đạo hôm nay</li>
          {/* <li className="menu-list__item" style={feature === FEATURES.WEATHER ? styleActive : styleInActive} onClick={()=> {
            gotoFeature(FEATURES.WEATHER)
          }}>Thời tiết (Sớm có!)</li> */}
          <li className="menu-list__item" style={feature === FEATURES.LIFENUMBER ? styleActive : styleInActive} onClick={()=> {
            gotoFeature(FEATURES.LIFENUMBER)
          }}>Thần Số Học của bạn</li>
          <li className="menu-list__item" style={feature === FEATURES.TRA_CUU_PHAT_NGUOI ? styleActive : styleInActive} onClick={()=> {
            gotoFeature(FEATURES.TRA_CUU_PHAT_NGUOI)
          }}>Tra cứu phạt nguội xe oto</li>
           {/* <li className="menu-list__item" style={feature === FEATURES.MINI_GAME ? styleActive : styleInActive} onClick={()=> {
            // gotoFeature(FEATURES.MINI_GAME)
          }}>Mini game (Sớm có!)</li> */}
        </ul>
      </nav>
    </div>
  );
}
